import React from 'react';
import type { ComponentProps, ReactElement } from 'react';

import type { Paragraph as OriginalParagraph } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

/** Standalone paragraphs with non-text children can render light; nested paragraphs upgrade with their root. */
export const Paragraph = ({
	children,
	dataAttributes,
	localId,
	asInline,
	lightNodeRef,
}: ComponentProps<typeof OriginalParagraph> & LightNodeProps): ReactElement => (
	// eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- Preserve renderer paragraph attributes and its existing DOM boundary.
	<p {...dataAttributes} ref={lightNodeRef} data-local-id={localId} data-as-inline={asInline}>
		{React.Children.toArray(children).length === 0 ? '\u00a0' : children}
	</p>
);
